<div class="auction-card-cntr" [ngClass]="configuration.cssClass"
    (click)="configuration.isClickEnabled ? configuration.click() : show()">

    <div class="img-cntr">

        <img *ngIf="configuration.batch.ProductFiles.length" [src]="configuration.batch.ProductFiles[0].Endpoint" alt="" />

    </div>

    <div class="body-cntr">

        <div class="title-cntr">

            <div style="width: 80%">

                <h3>{{ configuration.batch.Name }}</h3>

            </div>

            <div class="button" style="width: 16%" [ngClass]="{'button-blue': getIsMultipleBatch()}">

                <i class="pi pi-arrow-right" style="font-size: 1.2rem; color: white"></i>

            </div>

        </div>

        <div class="info-cntr">


            <div class="bid-info">

                <h4 class="gray">Prezzo</h4>
                <h4>{{ configuration.batch.StartingPrice }} €</h4>

            </div>

            <div class="bid-info">

                <h4 class="gray">Quantità</h4>
                <h4>{{ configuration.batch.ProductQuantity }} {{getMeasuringUnitTranslation(configuration.batch.MeasuringUnit)}} </h4>

            </div>

            <div class="bid-info">

                <h4 class="gray">Venditore</h4>
                <h4>{{ configuration.batch.CreatedBy }} </h4>

            </div>

            <!-- <ng-container *ngIf="userService.roleChecker.is.customer();else businessTemplate">

                <div class="bid-info">

                    <h5 class="gray">Posizione</h5>
                    <h4>{{ 1 }}</h4>
                </div>

            </ng-container>

            <ng-template #businessTemplate>

                <div class="bid-info">

                    <h5 class="gray">Nr. Partecipanti</h5>
                    <h4>{{ 1 }}</h4>

                </div>

            </ng-template> -->

            <!-- <div class="bid-info" style="min-width: 60px">

                <ng-container *ngIf="configuration.time; else closedTemplate">

                    <h5 class="gray">Tempo</h5>

                    <ng-container *ngIf="isDateInThePast(); else timerTemplate">

                        <h4>Programmato</h4>

                    </ng-container>

                    <ng-template #timerTemplate>

                        <cd-timer #auctionTimer [countdown]="true" [startTime]="configuration.time" format="hms"
                            maxTimeUnit="hour"></cd-timer>

                    </ng-template>

                </ng-container>

                <ng-template #closedTemplate>

                    <h5 class="gray">Stato</h5>
                    {{ getBatchAvailabilityStatusTranslation(configuration.batch.BatchAvailabilityStatus) }}
                </ng-template>
            </div> -->
        </div>
    </div>
</div>
